import React, { Component } from "react";
import { getAppState, withAppState } from "../../state";
import { i18n } from "../../services/i18nService";
import { ContainerStyled } from "../../styles/shared-styles";
import { SettingsPageStyled, BlockStyled, SettingsHeading } from "./styles/Styled";
import { SecondaryMenu, Loading } from "../../services/visualLibraryService";
import { config } from "../../config/config";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { getSdk } from "../../services/sdkService";
import {
  Languages,
  Profile,
  Devices,
  History,
  ParentalControl,
  AccountStatus,
  ContactUs,
  Help,
  Logout,
  ExitApp,
  EVoucher
} from "./subsections";
import { logout } from "../../services/authenticationService";
import { checkVoucherEligiblity } from "../../services/eVoucherEligibilityService";
import { getGlobalButtonFocusPath, getGlobalButtonInfo } from "../../errors/globalButtons";
import { trackPage, trackEvent } from "../../services/analyticsService";
import { isAccessAllowedByParentalLevel } from "../../services/parentalControlService";
import { redirectTo } from "../../services/navigationService";
import { routes } from "../../routes";
import { showForceLogoutError } from "../../services/modalsService";
import { LogoStyled, LineSeparator } from "./styles/Styled";
import getRemoteKey from "../../services/remoteService";
import FreeLogo from "../../components/FreeLogo";
import * as Sentry from "@sentry/browser";
import { getTVODAssetsStatus } from "../../services/tvodService";
import { getLast3MonthsData } from "../../utils/tvodUtils";

const PAGE = "settings";
const LOGOUT = "logout";
const EXIT = "exit";
const LANGUAGE = "language";
const PROFILE = "profile";
const EVOUCHER = "eVoucher";
const PARENTAL_CONTROL = "parentalControl";
const DEVICES = "devices";
const HISTORY = "history";

let menuItems = null;
let eVoucherData;
let isModalOpen = false;

function getLanguagesList(locales) {
  const currentLanguage = i18n.getLocale();
  const languages = [];
  for (let key in locales) {
    if (locales.hasOwnProperty(key)) {
      const lang = {
        title: i18n.getWithLocale(`global.languages.${key}`, key),
        languageCode: key,
        active: key === currentLanguage,
        extraClassName: key === "ar" ? "sansSerifFontFamily" : ""
      };
      languages.push(lang);
    }
  }
  return languages;
}

function getExitConfirmationOptions() {
  return [
    {
      title: i18n.get("global.no"),
      callback: function() {
        this.lastSelectedSectionIndex && this.props.setFocus(`secondaryItem_${this.lastSelectedSectionIndex}`);
      }
    },
    {
      title: i18n.get("global.yes"),
      callback: function() {
        trackEvent(PAGE, "confirm exit app", "confirm exit app");
        resetUserSettingsData();
        getSdk().systemManager.application.exit();
      }
    }
  ];
}

function resetUserSettingsData() {
  eVoucherData = null;
}

function getDefaultSectionContentFocus() {
  return getAppState().userLogged ? (isAccessAllowedByParentalLevel() ? PROFILE : PROFILE) : LANGUAGE;
}

class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      sectionLoaded: false,
      activeSubsection: getDefaultSectionContentFocus.call(this),
      languageList: getLanguagesList(config.get().locales),
      parentalControlList: config.get().parentalControlList,
      userAccount: null,
      userDevices: null,
      userHistory: []
    };
    this.changeLanguage = this.changeLanguage.bind(this);
    this.changeParentalLevel = this.changeParentalLevel.bind(this);
    this.onClickDevice = this.onClickDevice.bind(this);
    this.hideSettingsModal = this.hideSettingsModal.bind(this);
    this.getMenuItems = this.getMenuItems.bind(this);
    this.changeSubsection = this.changeSubsection.bind(this);
    this.applyConfirmation = this.applyConfirmation.bind(this);
    this.doChangeParentalLevel = this.doChangeParentalLevel.bind(this);
    this.showGlobalModal = this.showGlobalModal.bind(this);
    this.showLogoutModal = this.showLogoutModal.bind(this);
    this.getLogoutConfirmationOptions = this.getLogoutConfirmationOptions.bind(this);
    this.getSectionIndex = this.getSectionIndex.bind(this);
    this.getVoucherSectionIndex = this.getVoucherSectionIndex.bind(this);
    this.voucherHandleEnter = this.voucherHandleEnter.bind(this);
    this.updateHistory = this.updateHistory.bind(this);
    this.page = 1;
    this.pageSize = 3;
    this.isBottonShowing = true;
    this.isPurchaseHistoryLoadedFirstTime = true;
  }

  getSectionIndex(sectionName) {
    return this.getMenuItems().findIndex(item => item.name === sectionName);
  }

  getDefaultMenuItemIndex() {
    return isAccessAllowedByParentalLevel() ? 0 : this.getSectionIndex(PROFILE);
  }

  getDefaultMenuItemFocused() {
    const {
      applicationState: { globalModal },
      setFocus
    } = this.props;
    const index = this.getDefaultMenuItemIndex();

    if (!globalModal) {
      setFocus(`secondaryItem_${index}`);
    }
  }

  getDefaultMenuItemSelected() {
    const { history } = this.props;
    const index = this.getDefaultMenuItemIndex();
    this.secondaryMenuSelectedIndex = index;
    history.replace({
      state: {
        secondaryMenuSelectedIndex: index
      }
    });
  }

  keydownHandler = e => {
    const { applicationState, setFocus, pauseNavigation, resumeNavigation } = this.props;
    const pressedKey = getRemoteKey(e.keyCode);
    if (pressedKey === "ARROW_UP") {
      if (applicationState.currentFocus === "selectorItem_0") {
        setFocus(`selectorItem_0`);
        pauseNavigation();
      } else {
        resumeNavigation();
      }
    } else if (pressedKey === "ARROW_DOWN") {
      const activeSubsectionLength = this.getSubsectionListLength(this.state.activeSubsection);
      if (applicationState.currentFocus === `selectorItem_${activeSubsectionLength}`) {
        setFocus(`selectorItem_${activeSubsectionLength}`);
        pauseNavigation();
      } else {
        resumeNavigation();
      }
    } else if (pressedKey === "ARROW_LEFT") {
      if (isModalOpen) {
        pauseNavigation();
      } else {
        i18n.getDirection() === i18n.directions.RIGHT_TO_LEFT
          ? resumeNavigation()
          : setFocus(`secondaryItem_${this.secondaryMenuSelectedIndex}`);
      }
    } else if (pressedKey === "ARROW_RIGHT") {
      if (isModalOpen) {
        pauseNavigation();
      } else {
        i18n.getDirection() === i18n.directions.RIGHT_TO_LEFT
          ? setFocus(`secondaryItem_${this.secondaryMenuSelectedIndex}`)
          : resumeNavigation();
      }
    }
    // NOTE: need to resume the navigation after pause navigation for Left and Right otherwise Enter press will not work
    if (isModalOpen) {
      resumeNavigation();
    }
  };

  async componentDidMount() {
    document.addEventListener("keydown", this.keydownHandler);
    trackPage.call(this, PAGE);
    if (!eVoucherData && isAccessAllowedByParentalLevel()) {
      eVoucherData = await checkVoucherEligiblity(false);
    }

    menuItems = this.generateMenuItems();
    this.getDefaultMenuItemSelected();
    getAppState().userLogged && (await this.getProfile());
    await this.setState({ isLoaded: true, sectionLoaded: true });
    this.getDefaultMenuItemFocused();
    // Force logout listening
    // showForceLogoutError.call(this);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.keydownHandler);
    eVoucherData = null;
  }

  changeLanguage(language) {
    this.dochangeLanguage(language);
  }

  async dochangeLanguage(language) {
    if (this.props.applicationState.userLocale !== language.languageCode) {
      try {
        await this.props.stateActions.setLocale(language.languageCode);
        // Force logout checks-  if yes , show the popup.
        showForceLogoutError.call(this);
        trackEvent(PAGE, "language change", language.languageCode);
      } catch (e) {
        Sentry.captureException(e);
        this.showGlobalModal();
      }
    }
    this.setState(() => {
      menuItems = this.generateMenuItems();
      return { languageList: getLanguagesList(config.get().locales) };
    });
  }

  changeParentalLevel({ key }) {
    const {
      applicationState: { parentalLevel },
      history
    } = this.props;
    if (parentalLevel !== key) {
      const levels = getSdk().parentalControlLevels;
      if (levels.indexOf(parentalLevel) < levels.indexOf(key)) {
        return history.push({
          pathname: routes.parentalControl,
          state: {
            parentalLevel: key
          }
        });
      }
      this.doChangeParentalLevel(key);
    }
  }

  async onClickDevice(device) {
    isModalOpen = true;
    this.props.stateActions.showSettingsModal({
      modalTitle: i18n.get("pages.settings.devices.removeDevice"),
      modalText: device && device.title,
      buttons: [
        {
          ...getGlobalButtonInfo("delete"),
          buttonHandler: async () => {
            this.setState({ sectionLoaded: false }, async () => {
              this.hideSettingsModal();
              isModalOpen = false;
              await getSdk().userManager.deleteDevice(device.id);
              const userDevices = await getSdk().userManager.getDevices({ avoidCache: true });
              userDevices &&
                this.setState({ userDevices }, () => {
                  this.setState({ sectionLoaded: true });
                });
            });
          }
        },
        {
          ...getGlobalButtonInfo("cancel"),
          buttonHandler: () => {
            this.hideSettingsModal();
            isModalOpen = false;
          }
        }
      ],
      descriptionFontWeight: "bold"
    });
    this.props.setFocus(getGlobalButtonFocusPath("delete"));
  }

  hideSettingsModal() {
    this.props.stateActions.hideSettingsModal();
    this.lastSelectedSectionIndex && this.props.setFocus(`secondaryItem_${this.lastSelectedSectionIndex}`);
  }

  async doChangeParentalLevel(parentalLevel) {
    try {
      await this.props.stateActions.setParentalLevel(parentalLevel);
      // Force logout checks-  if yes , show the popup.
      showForceLogoutError.call(this);
      trackEvent(PAGE, "parental level change", parentalLevel);
      this.setState(() => {
        menuItems = this.generateMenuItems();
        return { languageList: getLanguagesList(config.get().locales) };
      });
    } catch (e) {
      Sentry.captureException(e);
      this.showGlobalModal(() => this.changeParentalLevel({ key: parentalLevel }));
    }
  }

  applyConfirmation(selectedOption) {
    if (selectedOption.callback) {
      selectedOption.callback.call(this);
    }
  }

  getMenuItems() {
    if (menuItems) {
      return menuItems;
    }
    return this.generateMenuItems();
  }

  getLogoutConfirmationOptions() {
    return [
      {
        title: i18n.get("pages.settings.logout.title").toUpperCase(),
        callback: function() {
          this.showLogoutModal();
        }
      }
    ];
  }

  redirectToStore() {
    return [
      {
        title: i18n.get("pages.settings.history.store").toUpperCase(),
        callback: function() {
          this.redirection();
        }
      }
    ];
  }

  redirection() {
    const { history } = this.props;
    history.push(routes.store);
  }
  async updateHistory() {
    let selectedIndex = this.state.userHistory && this.state.userHistory.length;
    this.setState({ sectionLoaded: false });
    this.page += 1;
    this.isPurchaseHistoryLoadedFirstTime = false;
    const history = await this.getHistory(this.pageSize, this.page);
    history && (history.length === 0 || history.length === 1 || history.length === 2)
      ? (this.isBottonShowing = false)
      : (this.isBottonShowing = true);
    if (history) {
      let userHistory = [...this.state.userHistory, ...history];
      userHistory && this.setState({ userHistory });
    }
    this.setState({ sectionLoaded: true });

    if (history.length < 3) {
      selectedIndex = selectedIndex - 1;
    }
    this.props.setFocus(`selectorItem_${selectedIndex}`);
  }

  showLogoutModal() {
    isModalOpen = true;
    this.props.stateActions.showSettingsModal({
      modalText: i18n.get("pages.settings.logout.areYouSure"),
      modalTitle: i18n.get("pages.settings.logout.title"),
      buttons: [
        {
          ...getGlobalButtonInfo("yes"),
          buttonHandler: async () => {
            const { history, stateActions } = this.props;
            trackEvent(PAGE, "confirm logout", "confirm logout");
            const isResetXToken = true;
            await logout(isResetXToken);
            isModalOpen = false;
            stateActions.userLoggedOut();
            resetUserSettingsData();
            menuItems = this.generateMenuItems();
            history.push(routes.home);
            this.props.stateActions.hideSettingsModal();
          }
        },
        {
          ...getGlobalButtonInfo("no"),
          buttonHandler: () => {
            isModalOpen = false;
            this.props.stateActions.hideSettingsModal();
            this.lastSelectedSectionIndex && this.props.setFocus(`secondaryItem_${this.lastSelectedSectionIndex}`);
          }
        }
      ]
    });
    this.props.setFocus(getGlobalButtonFocusPath("no"));
  }

  showGlobalModal(retryCallback) {
    isModalOpen = true;
    const online = !!getAppState().isOnline;
    const errorText = online
      ? i18n.get("global.errors.genericError")
      : i18n.get("global.errors.internetConnectivity.text");
    this.props.stateActions.showGlobalModal({
      modalText: errorText,
      modalTitle: !online && i18n.get("global.errors.internetConnectivity.title"),
      buttons: [
        {
          ...getGlobalButtonInfo("retry"),
          buttonHandler: async () => {
            this.props.stateActions.hideGlobalModal();
            isModalOpen = false;
            if (typeof retryCallback === "function") {
              try {
                await retryCallback.call(this);
                this.lastSelectedSectionIndex && this.props.setFocus(`secondaryItem_${this.lastSelectedSectionIndex}`);
              } catch (e) {
                Sentry.captureException(e);
                this.showGlobalModal(retryCallback);
              }
            } else {
              this.componentDidMount.bind(this);
            }
          }
        },
        {
          ...getGlobalButtonInfo("close"),
          buttonHandler: () => {
            isModalOpen = false;
            this.props.stateActions.hideGlobalModal();
            this.props.history.goBack();
          }
        }
      ]
    });
    this.props.setFocus(getGlobalButtonFocusPath("retry"));
  }

  async getProfile() {
    const userAccount = this.state.userAccount || (await getSdk().userManager.get());
    userAccount && this.setState({ userAccount });
  }

  async getAccountStatus() {
    const userAccount = this.state.userAccount || (await getSdk().userManager.get({ avoidCache: true }));
    userAccount && (userAccount.billing = await getSdk().userManager.getBilling({ avoidCache: true }));
    userAccount && this.setState({ userAccount });
  }

  async getDevices() {
    const userDevices = this.state.userDevices || (await getSdk().userManager.getDevices({ avoidCache: true }));
    userDevices && this.setState({ userDevices });
  }

  async getHistory(pageSize, pageNo) {
    const historyData = await getTVODAssetsStatus(null, pageSize, pageNo);
    if (getLast3MonthsData(historyData).length !== 0) {
      return historyData;
    } else {
      return [];
    }
  }

  generateMenuItems() {
    const {
      applicationState: { parentalLevel }
    } = this.props;
    const subsectionCallbacks = {
      profile: async () => {
        try {
          await this.getProfile();
        } catch (e) {
          await this.props.stateActions.setForceLogout(e);
          // if Force logout show the popup
          if (!!getAppState().forceLogout) {
            await showForceLogoutError.call(this);
            return;
          }
          Sentry.captureException(e);
          this.showGlobalModal(this.getProfile);
        }
      },
      accountStatus: async () => {
        try {
          await this.getAccountStatus();
        } catch (e) {
          Sentry.captureException(e);
          await this.props.stateActions.setForceLogout(e);
          // if Force logout show the popup
          if (!!getAppState().forceLogout) {
            await showForceLogoutError.call(this);
            return;
          }
          this.showGlobalModal(this.getAccountStatus);
        }
      },
      devices: async () => {
        try {
          await this.getDevices();
        } catch (e) {
          Sentry.captureException(e);
          await this.props.stateActions.setForceLogout(e);
          // if Force logout show the popup
          if (!!getAppState().forceLogout) {
            await showForceLogoutError.call(this);
            return;
          }
          this.showGlobalModal(this.getDevices);
        }
      },
      history: async () => {
        try {
          const userHistory = await this.getHistory(this.pageSize, this.page);

          let updatedUserHistory = [];
          if (this.isPurchaseHistoryLoadedFirstTime) {
            updatedUserHistory = [...userHistory];
          } else if (this.page === 1 && !this.isPurchaseHistoryLoadedFirstTime) {
            updatedUserHistory = [...this.state.userHistory, ...userHistory];
          } else {
            updatedUserHistory = [...this.state.userHistory];
          }
          userHistory && this.setState({ userHistory: updatedUserHistory });
        } catch (e) {
          Sentry.captureException(e);
          await this.props.stateActions.setForceLogout(e);
          // if Force logout show the popup
          if (!!getAppState().forceLogout) {
            await showForceLogoutError.call(this);
            return;
          }
          this.showGlobalModal(this.getHistory);
        }
      }
    };
    const userLogged = getAppState().userLogged;

    menuItems = config
      .get()
      .settingsSubsections.filter(item => (!eVoucherData ? item.name !== EVOUCHER : item))
      .filter(
        item =>
          this.state.parentalControlList.indexOf(item.minimumParentalLevel) <=
          this.state.parentalControlList.indexOf(parentalLevel)
      );

    menuItems.forEach(item => {
      const languageKey = `pages.settings.menu.${item.name}`;
      const languageValue = i18n.get(`pages.settings.menu.${item.name}`);
      item.tagTitle = languageKey !== languageValue ? languageValue : i18n.get(`global.${item.name}`);
      item.beforeSubsectionEnter = subsectionCallbacks[item.name];
      item.show = !item.onlyLoggedIn || item.onlyLoggedIn === userLogged;
    });
    return menuItems.filter(item => (item.show !== undefined ? item.show : true));
  }

  async changeSubsection(index) {
    this.secondaryMenuSelectedIndex = index;
    this.setState({ sectionLoaded: false });
    const selectedSection = Object.values(this.getMenuItems())[index];
    this.lastSelectedSectionIndex = index;
    selectedSection.beforeSubsectionEnter && (await selectedSection.beforeSubsectionEnter());
    this.setState({ activeSubsection: selectedSection.name, sectionLoaded: true });
    // this.page = 1;
    // this.isBottonShowing = true;
    trackPage.call(this, PAGE);
    if (
      selectedSection.name === LOGOUT ||
      selectedSection.name === EXIT ||
      selectedSection.name === HISTORY ||
      (selectedSection.name === DEVICES && this.state.userDevices.length > 0)
    ) {
      this.props.setFocus("selectorItem_0");
    } else if (selectedSection.name === LANGUAGE) {
      const selectedLanguageIndex = this.state.languageList.findIndex(item => item.active);
      this.props.setFocus(`selectorItem_${selectedLanguageIndex}`);
    } else if (selectedSection.name === PARENTAL_CONTROL) {
      const parentalLevel = this.props.applicationState.parentalLevel;
      const selectedParentalControlIndex = this.state.parentalControlList.findIndex(
        item => item === parentalLevel.toString()
      );
      this.props.setFocus(`selectorItem_${selectedParentalControlIndex}`);
    }
  }

  getSubsectionLayout(subsection) {
    const subsections = {
      language: (
        <Languages
          languagesList={this.state.languageList}
          onItemSelected={this.changeLanguage}
          isFromSettingsPage={true}
        />
      ),
      profile: this.state.userAccount && <Profile userAccount={this.state.userAccount} />,
      parentalControl: (
        <ParentalControl
          parentalControlList={this.state.parentalControlList}
          onItemSelected={this.changeParentalLevel}
        />
      ),
      accountStatus: this.state.userAccount && <AccountStatus userAccount={this.state.userAccount} />,
      devices: this.state.userDevices && (
        <Devices devices={this.state.userDevices} onItemSelected={this.onClickDevice} />
      ),
      history: (
        <History
          historylist={this.state.userHistory}
          onItemSelected={
            this.state.userHistory && this.state.userHistory.length > 0 ? this.updateHistory : () => this.redirection()
          }
          isBottonShowing={this.isBottonShowing}
          confirmationOptions={this.redirectToStore()}
          isFromSettingsPage={true}
        />
      ),
      contactUs: <ContactUs />,
      help: <Help />,
      logout: (
        <Logout
          confirmationOptions={this.getLogoutConfirmationOptions()}
          onItemSelected={this.applyConfirmation}
          isFromSettingsPage={true}
        />
      ),
      exit: <ExitApp confirmationOptions={getExitConfirmationOptions()} onItemSelected={this.applyConfirmation} />,
      ...(!!eVoucherData && {
        eVoucher: (
          <EVoucher
            enterHandler={this.voucherHandleEnter}
            sectionItemFocused={this.lastSelectedSectionIndex || this.getVoucherSectionIndex()}
          />
        )
      })
    };
    return subsections[subsection];
  }

  getSubsectionListLength(subsection) {
    switch (subsection) {
      case "language":
        return this.state.languageList.length;
      case "parentalControl":
        return this.state.parentalControlList.length;
      case "devices":
        return this.state.userDevices.length;
      case "history":
        return this.state.userHistory.length;
      case "logout":
        return 1; // as we have only one button
      default:
        return 1;
    }
  }

  getVoucherSectionIndex() {
    return this.getSectionIndex(EVOUCHER);
  }

  voucherHandleEnter() {
    const userLogged = getAppState().userLogged;
    const eventAction = userLogged ? "settings_user_selects_startnow" : "settings_user_selects_joinnow";
    const path = userLogged ? routes.redeem : routes.signup;
    trackEvent("signup", eventAction);
    redirectTo.call(this, path);
  }

  render() {
    return (
      <SettingsPageStyled>
        {this.state.isLoaded ? (
          <>
            <LineSeparator />
            <LogoStyled>
              <FreeLogo />
            </LogoStyled>
            <SettingsHeading rank={1} text={i18n.get("pages.settings.title")} size={"large"} fontWeight="regular" />
            <ContainerStyled>
              <BlockStyled>
                <SecondaryMenu
                  items={this.getMenuItems()}
                  onClick={this.changeSubsection}
                  currentFocus={this.props.applicationState.currentFocus}
                  secondaryMenuSelectedIndex={this.secondaryMenuSelectedIndex}
                  isFromSettingsPage={true}
                  size="medium"
                  weight="semiBold"
                />
              </BlockStyled>
              <BlockStyled>
                {this.state.sectionLoaded ? (
                  this.getSubsectionLayout(this.state.activeSubsection)
                ) : (
                  <Loading overlay opacity="0" />
                )}
              </BlockStyled>
            </ContainerStyled>
          </>
        ) : (
          <Loading overlay />
        )}
      </SettingsPageStyled>
    );
  }
}

export default withAppState(withSubtheme(Settings));
